import React from 'react';
import { Box, Container, Typography, Button } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';

const Hero: React.FC = () => {
  const scrollToAppointment = () => {
    const element = document.getElementById('appointment');
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <Box
      id="home"
      sx={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        background: 'linear-gradient(135deg, #9c4f96 0%, #c084bb 100%)',
        pt: 8,
      }}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            display: 'flex',
            flexDirection:  { xs: 'column', md:  'row' },
            alignItems: 'center',
            gap: 4,
          }}
        >
          <Box sx={{ flex: 1, color: 'white' }}>
            <Typography variant="h2" component="h1" gutterBottom sx={{ fontWeight: 700 }}>
              Thayne Silva Prado
            </Typography>
            <Typography variant="h4" gutterBottom sx={{ color: '#f0e6ef' }}>
              Cirurgiã Dentista
            </Typography>
            <Typography variant="h6" sx={{ mb: 3, color: '#f5f5f5' }}>
              CRO/PR. 38004
            </Typography>
            <Typography variant="body1" sx={{ mb: 4, fontSize: '1.1rem', lineHeight: 1.8 }}>
              Cuidando do seu sorriso com excelência e dedicação.  
              Atendimento humanizado e tecnologia de ponta para garantir 
              sua saúde bucal e bem-estar.
            </Typography>
            <Button
              variant="contained"
              size="large"
              startIcon={<CalendarMonth />}
              onClick={scrollToAppointment}
              sx={{
                bgcolor: 'white',
                color: '#9c4f96',
                py: 1.5,
                px: 4,
                fontSize: '1.1rem',
                '&:hover': { bgcolor: '#f5f5f5', transform: 'scale(1.05)' },
                transition: 'all 0.3s',
              }}
            >
              Agende sua Consulta
            </Button>
          </Box>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              justifyContent:  'center',
              alignItems: 'center',
            }}
          >
            <Box
              component="img"
              src="/logo.png"
              alt="Logo Thayne Silva Prado"
              sx={{
                width:  '100%',
                maxWidth:  400,
                height: 'auto',
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Hero;